<template>
  <StepLayout
    pageId="page-5"
    contentId="orderSuccessful-mod"
    contentClass="orderDetial-mod"
  >
    <template #title>
      <h3><i></i>Booking Successful!</h3>
    </template>
    <ul class="order-details">
      <li class="storeName-col">
        Thank you for your reservation at <strong id="orderSuccessfulName">{{ storeName }}</strong>
      </li>
    </ul>
    <ul class="order-details">
      <li class="name-col">
        Customer:
        <strong id="orderName">
          <span id="orderFirstName">{{ infoForm.firstName }}</span>&nbsp;
          <span id="orderLastName">{{ infoForm.surname }}</span>
        </strong>
      </li>
    </ul>
    <ul class="order-details">
      <li class="date-col">
        Date: <strong id="orderDate">{{ currentDate }}</strong>
      </li>
      <li class="week-col">
        On: <strong id="orderWeek">{{ week }}</strong>
      </li>
      <li class="time-col">
        Time: <strong id="orderTime">{{ currentTime }}</strong>
      </li>
    </ul>
    <ul class="order-details">
      <li class="people-col">
        People: <strong id="orderPeople">{{ currentSize }} px</strong>
      </li>
      <li class="phone-col">
        Phone:
        <strong id="orderPhone">
          <span v-show="infoForm.areaCode !== '' || infoForm.areaCode !== ' '">{{ infoForm.areaCode }} </span>
          {{ infoForm.phone }}
        </strong>
      </li>
    </ul>
    <ul class="order-details">
      <li class="email-col">
        Email: <strong id="orderEmail">{{ infoForm.email }}</strong>
      </li>
    </ul>
    <ul class="order-details" id="depositCol" v-show="depositPrice !== ''">
      <li class="deposit-col">
        Deposit <strong id="orderDeposit">&pound;{{ depositPrice }}</strong>
      </li>
    </ul>
    <div class="successBtnCol">
      <a id="backSelectDate" @click="makeAnotherBook">Make another reservation</a>
    </div>
    <div class="successBtnCol icsBtnCol">
      <a :href="ics_url" target="_blank" id="getICSlik">
        <a-icon type="calendar" />Add to calendar
      </a>
    </div>
  </StepLayout>
</template>
<script>
import StepLayout from "./StepLayout.vue";

export default {
  name: "ReservationStep6",
  components: {
    StepLayout
  },
  props: {
    storeName: String,
    infoForm: Object,
    currentDate: String,
    week: String,
    currentTime: String,
    currentSize: [String, Number],
    depositPrice: [String, Number],
    ics_url: String
  },
  methods: {
    makeAnotherBook() { this.$emit("makeAnotherBook"); }
  }
};
</script>

<style lang="scss">
.date-col,.week-col,.people-col {
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ReservationStep6.vue